export default "__VITE_ASSET__BzjEhGdL__"